export default __webpack_public_path__ + "static/media/32.1bcd526a.svg";